export const DATA_GRID_DEFAULTS = {
    initialState: {
        pagination: {
            paginationModel: {
                page: 0,
                pageSize: 25,
            },
        },
    },
    slotProps: {
        toolbar: {
            csvOptions: { allColumns: true },
            printOptions: { allColumns: true },
        },
        pagination: {
            labelRowsPerPage: 'Rows per page:',
            labelDisplayedRows: ({ from, to, count }) => `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
        },
    },
    autoHeight: false,
    disableColumnMenu: false,
    disableRowSelectionOnClick: true,
    paginationMode: 'server',
    sortingMode: 'server',
    filterMode: 'server',
    pageSizeOptions: [5, 10, 25],
    density: 'standard',
    rowHeight: 52,
    columnHeaderHeight: 56,
};

export const defaultPaginationModel = {
    page: 0,
    pageSize: 25,
};
